import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=565571bc&scoped=true&"
import script from "./Culture.vue?vue&type=script&lang=js&"
export * from "./Culture.vue?vue&type=script&lang=js&"
import style0 from "./Culture.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Culture.vue?vue&type=style&index=1&id=565571bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565571bc",
  null
  
)

export default component.exports